/* eslint one-var: [0]*/

import Utils from '../utils/utils.js';
import Api from '../utils/api.js';

const api = new Api();

export default class DayHighlightChooser {
	init( result ){
		const self = this;
		const fontsLoaded = jQuery( 'html' ).hasClass( 'wf-sofiapro-n7-active' ) && jQuery( 'html' ).hasClass( 'wf-sofiapro-n4-active' );
		const fire = ( ctx, res ) => {
			setTimeout( () => {
				ctx.append( res );
				// ctx.buildTimeline();
				ctx.initEvents();				
			}, 150 );
		};

		if ( typeof result === 'undefined' ){
			api.getAllDays().then( ( _result ) => {
				fire( this, _result );
			} );
		} else {
			fire( this, result );
		}
	}

	initEvents(){
		const self = this;

		this.$chooserToggle.on( 'click', ( event ) => {
			const $target = jQuery( event.target ).is( 'button' ) ? jQuery( event.target ) : jQuery( event.target ).closest( 'button' );
			const $select = jQuery( `#${$target.attr( 'aria-controls' )}` );
		} );

		/*
		 * On Select Change
		 *
		 */
		this.$chooserSelect.on( 'change', ( event ) => {
			const $target = jQuery( event.target ).is( 'select' ) ? jQuery( event.target ) : jQuery( event.target ).closest( 'select' ),
				scope = $target.val(),
				label = $target.find( `[value="${scope}"]` ).data( 'label' );

			self.$chooserCurrentValue.text( label );
			self.changeEvents( scope );

			event.preventDefault();
		} );
	}

	append( days ){
		const self = this,
			dayHighlightChooser = jQuery( '<div class="c-event-highlights__filter-chooser absolute right-0 top-0"><ul class="list-reset m-0 uppercase text-right leading-none c-event-highlights__filter-chooser-list"></ul></div>' ),
			dayHighlightChooserSelect = jQuery( '<select class="c-event-highlights__filter-select opacity-0 absolute top-0 bottom-0 right-0 left-0 text-right w-full" id="c-event-highlights__filter-select"></select>' ),
			dayHighlightChooserParent = jQuery( '.c-event-highlights__filter ' ),
			dayHighlightChooserList = dayHighlightChooser.find( '.c-event-highlights__filter-chooser-list' ),
			dayHighlightChooserCurrent = jQuery( '.c-event-highlights__filter-date-current' ),
			dayHighlightChooserCurrentValue = jQuery( '.c-event-highlights__filter-date-current-value' ),
			dayHighlightChooserDate = jQuery( '.c-event-highlights__filter-date' ),			
			dayHighlightToggle = jQuery( '.c-btn-select-toggle' ),
			currentDate = dayHighlightChooserCurrent.data( 'initScope' );
			// currentDate = Utils.getCurrentDate();
      
		/*
		 * Build List
		 */
		days.forEach( ( el ) => {
			const listItem = jQuery( `<li class="c-event-highlights__filter-chooser-list-item" data-value="${el.scope}"><span>${el.format}</span></li>` );
			if ( el.scope === currentDate ){
				listItem.addClass( 'is-current' );
			}
			dayHighlightChooserSelect.append( `<option data-label="${el.format}" value="${el.scope}"${el.scope === currentDate ? ' selected' : ''}>${el.format}</option>` );
			dayHighlightChooserList.append( listItem );
		} ); 

		dayHighlightChooserList.wrap( '<div class="c-event-highlights__filter-chooser-list-container">' ).wrap( '<div class="c-event-highlights__filter-chooser-list-container-inner">' );
		
		dayHighlightChooserCurrent.append( dayHighlightChooserSelect );
		
		/*
		 * Append to DOM
		 * dayHighlightChooserParent.prepend( dayHighlightChooser );
		 */

		// assign vars
		this.$chooser = dayHighlightChooser;
		this.$chooserParent = dayHighlightChooserParent;
		this.$chooserSelect = dayHighlightChooserSelect;
		this.$chooserList = dayHighlightChooserList;
		this.$chooserCurrent = dayHighlightChooserCurrent;
		this.$chooserCurrentValue = dayHighlightChooserCurrentValue;
		this.$chooserDate = dayHighlightChooserDate;
		// this.$chooserMorph = dayHighlightChooserMorph;
		this.$chooserToggle = dayHighlightToggle;
		this.$chooserToggleArrow = dayHighlightToggle.find( '.c-btn-select-toggle__arrow' );
	}

	changeEvents( scope ){
		const self = this,
			$highlightList = jQuery( '.c-event-highlights__list' );
    
		Utils.progressBar( 'start' );
		
		api.getDayHighlightEvents( scope ).then( ( res ) => {
			Utils.progressBar( 'stop' );

			gsap.to( $highlightList, 0.5, {
				autoAlpha: 0,
				onComplete(){
					$highlightList.data( 'highlightLayout', res.length )
						.attr( 'data-highlight-layout', res.length );

					if ( res.length !== 0 ){
						for ( let i = 0; i < OAX.config.events.hightlights_limit; i++ ){
							const $listEl = $highlightList.find( `.c-event-highlights__item--${i + 1}` ),
								newEl = Utils.isset( res[i] ) ? res[i] : false;

							if ( newEl !== false ){
								$listEl.removeClass( 'hidden' );
								$listEl.html( newEl.rendered ); // .removeClass( 'hidden' );
							} else {
								$listEl.addClass( 'hidden' );
							}								
						}						
					} else {
						$highlightList.find( '.c-event-highlights__item' ).addClass( 'hidden' );
					}	
					
					gsap.to( $highlightList, 0.5, {
						autoAlpha: 1
					} );
				}
			} );
		} ); 

		this.setCookie( scope );
		$( document ).trigger( 'oax::event-teaser-next-prev', [scope] );
	}

	setCookie( scope ){
		const now = new Date();
		
		const expire = new Date();

		const cookieName = 'event_highlights_scope';

		expire.setFullYear( now.getFullYear() );
		expire.setMonth( now.getMonth() );
		expire.setDate( now.getDate() + 1 );
		expire.setHours( -1 );
		expire.setMinutes( 0 );
		expire.setSeconds( 0 );
		
		const expires = `expires=${expire.toString()}`;

		// document.writeln( `${expires}=> now =${now}` );
		document.cookie = `${cookieName}=${scope}; ${expires}; path=/`;
	}
}
